import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "col-12 px-0 pb-3 pt-4 clearfix" };
const _hoisted_2 = { class: "progress float-left" };
const _hoisted_3 = {
    class: "pl-0 text-right float-right",
    style: { "width": "40px" }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
                class: "progress-bar bg-brand_deep_blue",
                role: "progressbar",
                "aria-label": "Fortschrittsbalken",
                "aria-valuenow": "0",
                "aria-valuemin": "0",
                style: _normalizeStyle(`width: ${_ctx.progress_percent}%;`),
                "aria-valuemax": "100"
            }, null, 4)
        ]),
        _createElementVNode("div", _hoisted_3, _toDisplayString(`${_ctx.progress_percent}%`), 1),
        _createElementVNode("span", {
            title: "Schritt zurück",
            class: _normalizeClass(["d-lg-none link-in-text font7-responsive strong", { 'd-none': _ctx.current_step === 1 }]),
            onClick: _cache[0] || (_cache[0] = _withModifiers(
            //@ts-ignore
            (...args) => (_ctx.stepBackLink && _ctx.stepBackLink(...args)), ["prevent"]))
        }, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("i", { class: "icon-angle-circled-left" }, null, -1),
                _createTextVNode(" zurück ", -1)
            ]))], 2)
    ]));
}
